(() => {
  const initialize = () => document.querySelectorAll('header-component .header__menu-desktop dropdown-component').forEach(root => {
    if(root.dataset.mgHoverReady) return;
    root.dataset.mgHoverReady='true';
    const toggle=root.querySelector('[data-ref="dropdown-toggle"]');
    const content=root.querySelector('[data-ref="dropdown-content"]');
    if(!toggle || !content) return;
    content.id ||= 'mg-menu-'+Math.random().toString(36).slice(2,9);
    toggle.setAttribute('aria-controls',content.id);
    toggle.setAttribute('aria-expanded',String(root.dataset.open==='true'));
    const open=()=>{if(!matchMedia('(min-width:1001px)').matches || !root.open) return;root.closest('dropdown-group-component')?.closeAllDropdowns();root.open()};
    const close=()=>root.close?.();
    root.addEventListener('mouseenter',open);
    root.addEventListener('mouseleave',()=>{if(!root.contains(document.activeElement)) close()});
    root.addEventListener('focusin',open);
    root.addEventListener('focusout',event=>{if(!root.contains(event.relatedTarget)) close()});
    root.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();toggle.focus();close()}});
    new MutationObserver(()=>toggle.setAttribute('aria-expanded',String(root.dataset.open==='true'))).observe(root,{attributes:true,attributeFilter:['data-open']});
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true}); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();